import script from "./UserEditComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./UserEditComponent.vue?vue&type=script&setup=true&lang=js"

import "./UserEditComponent.vue?vue&type=style&index=0&id=73607c4f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73607c4f"]])

export default __exports__